/*公共js方法*/
var common = {}
common.install = (Vue,option)=>{
	const rootUrl = '/pc'
	let flag=0;	
	var handle = function(res,cb,that,f,resolve){
		if(res.status===200){
			/*正常情况下，或者需要返回全部数据时*/
			if(res.body&&(res.body.code===10000000||res.body.code===10000007||f)){
				if(typeof cb=='function')cb(res.body)
			/*未登陆时统一处理*/
			}else if(res.body&&res.body.code===10000012){
				window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
			/*通过后台配置三方配置接口拦截，显示信息后，返回首页*/
			}else if(res.body&&res.body.code===11000118){
				that.$Modal.warning({
					title: '提示',
					content: res.body.msg||'',
					onOk: () => {
						// window.location.href=location.origin+location.pathname
						window.location.href=location.origin
					}
				});
				/*其他情况下统一提示错误信息*/
			}else{
				that.alert(res.body.msg)
			}
			resolve&&resolve(res.body);
		}
	}
	/*封装ajax的post请求*/
	Vue.prototype.$post = function(url,cb,data={},f){
		url = rootUrl + url
		this.$Loading.start();
		flag++;
		if(typeof cb=='object')data=cb;
		/*vue-resource的ajax请求*/
		return new Promise((resolve,reject)=>{
			Vue.http.post(url,data,{
				timeout:60000
			}).then(res=>{
				handle(res,cb,this,f,resolve)
				if(--flag==0)this.$Loading.finish();
			},error=>{
				flag--;
				this.$Loading.error()
			})
		})
	}
	/*不带loading的ajax请求*/
	Vue.prototype.$postNo = function(url,cb,data={},f){
		url = rootUrl + url
		/*判断是否是在app里，如果是而且app关闭过，则从app拉取记录登录信息的token*/
		Vue.http.post(url,data,{
			headers:{},
			timeout:60000
		}).then(res=>{
			handle(res,cb,this,f)	
		})
	}
	/*公共检验方法*/
	Vue.prototype.rules = {
		tel:/^(1\d{10})$/,
		phone:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,
		telOrPhone:/^(1\d{10})|(\d{1,4}-?\d{7,8})$/,   //固话和手机
		code:/^\d{6}$/,
		pass:/^[\w\n\S]{6,20}$/,
		email:/^[A-Za-z\d]+([-_.A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
		idcard:/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([<0-9X></0-9X>x])$/,
		account:/^\d{2,20}$/,
		trim:/^ +| +$/, // 空格
		price:/^(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/, //非负数且最多两位小数
		chinaName: /^[A-Za-z0-9\u4e00-\u9fa5\.·]{1,20}$/,
		nickName:/^[0-9A-Za-z\u4E00-\u9FA5]{1,12}$/,
		telAndMobile:/^((\d{7,8})|(0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
		organizationCode:/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,// 统一社会信用代码
		alphanumeric: /^[A-Za-z0-9]+$/, // 只允许数字和字母
		identityCodeValid:(rule,code,callback)=>{
			var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
            var tip = "";
            var pass= true;
            if(!code || !/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([<0-9X></0-9X>x])$/i.test(code)){
            // if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/i.test(code)){
                tip = "身份证号格式错误";
                pass = false;
            }else if(!city[code.substr(0,2)]){
                tip = "身份证号格式错误";
                pass = false;
            }else{
                //18位身份证需要验证最后一位校验位
                if(code[code.length-1]=='x')code=code.replace('x','X')
                if(code.length == 18){
                    code = code.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                    //校验位
                    var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++)
                    {
                        ai = code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];
                    if(parity[sum % 11] != code[17]){
                        tip = "身份证号格式错误";
                        pass =false;
                    }
                }
            }
            if(!pass){
            	callback(new Error(tip))
            }else{
            	callback()
            }
            // return pass;
		}
	},
	/*toast*/
	Vue.prototype.toast = function(content,type,cb){
		this.$Message[type?type:'success']({
			content,
			onClose:cb
		})
	}
	/*alert*/
	Vue.prototype.alert = function(content,cb){
		this.$Notice.error({
            title: '系统提示',
            desc: content
        });
	}
	/*confirm*/
	Vue.prototype.confirm = function(content,cb,config={}){
		config={
			title: '提示',
			content: content,
			onOk:cb,
			...config
		}
		this.$Modal.confirm(config);
	}
		/**
	 * 计算相差月份
	 * @param  {[type]} startDate [description]
	 * @param  {[type]} endDate   [description]
	 * @return {[type]}           [description]
	 */
	Vue.prototype.getDateMonthSub = function (startDate, endDate) {
		if (startDate == null || startDate == undefined || startDate == "" || endDate == null || endDate == undefined || endDate == "")
			return 0;
		var endDate = new Date(endDate);
		var startDate = new Date(startDate);
		var renNumber = 0;
		var yearToMonth = (endDate.getFullYear() - startDate.getFullYear()) * 12;
		// 计算年份相差月份
		renNumber += yearToMonth;
		var startYear = startDate.getFullYear();// 开始日期-年份
		var endYear = endDate.getFullYear();// 结束日期-年份
		var startMon = startDate.getMonth();// 开始日期-月份
		var endMon = endDate.getMonth();// 结束日期-月份
		var startDay = startDate.getDate();// 开始日期-日
		var endDay = endDate.getDate();// 开始日期-日
		var monthToMonth = endDate.getMonth() - startDate.getMonth();
		// 计算月份相差
		renNumber += monthToMonth;
		// 如果开始日小于结束日，则月份+1;
		if (startDay < endDay) {
			renNumber += 1;
		}

		return renNumber;
	}
	/*格式化时间*/
	Vue.prototype.formatDate = function(date,fmt){
		if(!date)return '';
		date = new Date(date);
		fmt = fmt || 'yyyy-MM-dd';
		var o = {
	        "M+": date.getMonth() + 1, //月份 
	        "d+": date.getDate(), //日 
	        "h+": date.getHours(), //小时 
	        "m+": date.getMinutes(), //分 
	        "s+": date.getSeconds(), //秒 
	        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
	        "S": date.getMilliseconds() //毫秒 
	    };
	    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	    for (var k in o)
	    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	    return fmt;
	}
	/*获取之后的日期（用于获取保单截止日期）*/
	Vue.prototype.getAfterDay = function (year,date){
		// date = date || new Date()
		// let d = this.formatDate(new Date(date).getTime()-24*60*60*1000,'MM-dd');
		// let y = new Date(date).getFullYear()+(year-0)
		// return y +'-'+d
    	var date = this.formatDate(date||new Date());
    	var new_date='';
    	var year =year-0
    	var _y = date.split('-')[0]-0,
	    _m = date.split('-')[1]-0,
		_d = date.split('-')[2]-0;
	    if(_d==1){
	    	if(_m==3){
	    		if(_y%4==0||_y%400==0){//闰年
	    			new_date = new Date(_y+year,_m-1,_d-1)
			    }else{
			    	new_date = new Date(_y+year,_m-1,_d-1)
			    }
	    	}else if(_m==1){
	    		new_date = year==1?new Date(_y,11,31):new Date(_y+year-1,11,31)
	    	}else{
	    		new_date = new Date(_y+year,_m-1,_d-1)
	    	}
	    }else{
	    	new_date = new Date(_y+year,_m-1,_d-1)
	    }
	   return  new_date.getFullYear()+"-"
	   			+(new_date.getMonth()>=9?new_date.getMonth()+1:'0'
	   			+(new_date.getMonth()+1))+"-"
	   			+(new_date.getDate()>9?new_date.getDate():'0'
	   			+new_date.getDate());
	}
	/*获取两个日期相关的天数 天数 不带时分秒*/
	Vue.prototype.getDays = function(start,end) {
		let days = Date.parse(end)-Date.parse(start);
		days = days/1000/3600/24+1;
		return days;
	}
	/*获取大图的地址*/
	Vue.prototype.getOriginImg = function (url) {
		if(url.indexOf('_m')>-1){
			return url
		}else{
			return url.replace(/\.jpg/gi,'_m.jpg').replace(/\.png/gi,'_m.png')
		}
	}
	/*根据身份证号获取性别*/
	Vue.prototype.getSexFromId = function (idCard){
		if(idCard.length==18){
			return idCard[idCard.length-2]%2==0?'2':'1'
		}else{
			return idCard[idCard.length-1]%2==0?'2':'1'
		}
	}
	/*获取之前的日期 投保最大年龄（用于计算投保周期）*/
	Vue.prototype.getBeforeDay = function (year){
		let d = this.formatDate(new Date().getTime()+24*60*60*1000,'MM-dd');
		let y = new Date().getFullYear()-year-1
		return y +'-'+d
	}
	/*获取投保限制日期 最小年龄*/
	Vue.prototype.getDeadline = function (year,date){
		date = date || new Date();
		let d = this.formatDate(new Date(date).getTime(),'MM-dd');
		let y = new Date(date).getFullYear()-year
		return y +'-'+d
	}
	/*
		判断年龄是否在投保期间内
		birthday:生日
		min:最小年龄
		max:最大年龄
	*/
	Vue.prototype.isInRange = function (birthday,min,max) {
		min = this.getDeadline(min);
		max = this.getBeforeDay(max);
		if(Date.parse(birthday)>Date.parse(min)||Date.parse(birthday)<Date.parse(max)){
			return false;
		}
		return true
	}
	/*根据身份证号提取出生日*/
	Vue.prototype.getBirthdayFromId = function(idCard){
		var birthday = "";  
	    if(idCard.length == 15){  
            birthday = "19"+idCard.substr(6,6);  
        } else if(idCard.length == 18){  
            birthday = idCard.substr(6,8);  
        } 
        birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");  
        return birthday
	}
	/*去登陆页面*/
	Vue.prototype.toLogin = function (url) {
		window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(url||location.href);
	}
	// 新窗口打开文件或图片
	Vue.prototype.openOriginFile = function(url){
		var ImgRules = /.((jpg)|(png)|(JPG)|(PNG)|(jpeg)|(JPEG))$/ig;
		if(!ImgRules.test(url)){
			//非图片
			window.open(url)
		}else{
			let largeImgUrl=this.ossImg(url);
			let image=new Image()
			image.src=largeImgUrl;
			image.onerror=()=>{
				window.open(url)
			}
			image.onload=()=>{
				window.open(largeImgUrl)
			}
		}
	}
	/*选择的图片验证类型以及大小*/
	Vue.prototype.compressImgPro = function (file) {
		return new Promise((resolve,reject)=>{
			var ImgRules = /.((jpg)|(png)|(JPG)|(PNG)|(jpeg)|(JPEG)|(tif)|(tiff))$/ig;
			if(!ImgRules.test(file.name)){
				this.alert('只能上传jpg,png类型的图片！')
				return false
			}
			let M=1024*1024;
			let fileSize=file.size;
			if(fileSize>20*M){
				this.alert('请上传不大于20M的图片！')
				return false
			}
			// tif特殊处理
			if(file.name.indexOf('.tif')>-1||file.name.indexOf('.tiff')>-1){
				resolve(file)
				return;
			}
			var reader = new FileReader();  
			reader.onload=e=>{
				var src = e.target.result;
				var image = new Image();  
				image.onload=()=>{  
					var width = image.width; 
					let quality=1;
					if(fileSize>10*M&&fileSize<=20*M){
						quality=0.4
					}else if(fileSize>1*M&&fileSize<=10*M){
						quality=0.5
					}else if(fileSize>700*1024&&fileSize<=1*M){
						quality=0.8
					}else if(fileSize>300*1024&&fileSize<=700*1024) {
						quality = 0.8
					}
					width>2000&&(width=2000)
					let param = {
						quality: quality
					}
					lrz(file,param).then(img=>{
						resolve(img)
					})
				};  
				image.src= src;  
			}
			reader.readAsDataURL(file);
		})
	}
	// 深拷贝
	Vue.prototype.jsonCopy = function (obj) {
		if(typeof obj=="undefined"){
			return obj;
		}else{
			return JSON.parse(JSON.stringify(obj))
		}
	}
	// OSS获取各尺寸路径
	Vue.prototype.ossImg = function (url,type='l') {
		if(url&&type=='s'){
			// small,小图
			url+=`?x-oss-process=style/small`
		}else if(url&&type=='m'){
			// middle,中图
			url+=`?x-oss-process=style/middle`
		}else if(url&&type=='l'){
			// large,大图
			url+=`?x-oss-process=style/large`
		}
		return url
	}
	// oss上传
	Vue.prototype.ossUpload = function(file){
		// type默认image,
		let type=file.type.indexOf('image')>-1?'image':'file'
		return new Promise(async (resolve,reject)=>{
			let uploadFile=null;
			let originName='';
			if(type=='image'){
				let img = await this.compressImgPro(file);
				if(!img)return
				if (img.origin) { // 正常处理
					uploadFile=img.file;
					originName=img.origin.name;
				} else { // 针对tif格式处理
					uploadFile=img;
					originName=img.name;
				}
				// uploadFile=img.file;
				// originName=img.origin.name;
			}else{
				uploadFile=file
				originName=file.name
			}
			let aliyunOss=await this.getOssSignature();
			let formData=new FormData();
			let fileName=this.calculateObjectName(aliyunOss.dir,originName)
			formData.append('key',fileName);
			formData.append('policy',aliyunOss.policy);
			formData.append('OSSAccessKeyId',aliyunOss.accessid);
			formData.append('success_action_status','200');
			// formData.append('callback',aliyunOss.callback);
			formData.append('signature',aliyunOss.signature);
			formData.append('file',uploadFile);

			this.$axios.post(aliyunOss.host+'.origin',formData,{
				headers:{
					"Content-Type":"multipart/form-data"
				},
				timeout:60000
			}).then(res=>{
				if(res.status==200){
					resolve({
						name:originName,
						url:aliyunOss.trackerOuterServerUrl+'/'+fileName
					})
				}else{
					console.log(res)
					reject('上传失败')
				}
			},error=>{
				reject(error)
			}).catch((error) => {
				throw new Error(error);
			})
		}).catch((error) => {
			throw new Error(error);
		})
	}
	// 获取OSS签名
	Vue.prototype.getOssSignature = function(){
		return this.$axios.post('/fileServer/ossSignature')
	}
	// 计算文件名
	Vue.prototype.calculateObjectName = function(key,filename){
		let pos = filename.lastIndexOf('.')
		let suffix = ''
		if (pos != -1) {
			suffix = filename.substring(pos)
		}
		return key + new Date().getTime() +this.randomString(16) + suffix
	}
	// 随机字符
	Vue.prototype.randomString = function(len) {
	　　len = len || 32;
	　　var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';   
	　　var maxPos = chars.length;
	　　var pwd = '';
	　　for (let i = 0; i < len; i++) {
		　　pwd += chars.charAt(Math.floor(Math.random() * maxPos));
		}
		return pwd;
	}
	/*统一导出*/
	Vue.prototype.exportToExcel = function(url,params={}){
		url = location.origin+rootUrl+url+'?';
		for(var i in params){
			url+=i+'='+(params[i]||'')+'&'
		}
		url = url.substring(0,url.length-1);
		// return;
		// console.log(url)
		window.location.href = url;
	}
	/*实时获取 session_key*/
	Vue.prototype.resetSetItem = async function () {
		if (!sessionStorage.track_session_key||(sessionStorage.track_session_key=='undefined')) {
			try{
				let session_key = await this.$fetch('/track/session-key');
				sessionStorage.track_session_key = session_key;
			}catch (e) {
				console.log(e,'000000000000')
			}
		}
  	},
	// 检测黑名单企业
	Vue.prototype.checkBlacklist = function(params){
        return this.$axios.post('/common/checkBlacklist.all',params)
    }
	/**
     * 从apollo获取前端配置RD.frontend
     * @param {} key 
     */
    Vue.prototype.getApolloConfig = function (key) {
        return new Promise((resolve, reject) => {
            this.$axios.get('/dingtalk/getDingTalkConfig', {
                key
            }).then(res => {
                try {
                    JSON.parse(res) && resolve(JSON.parse(res))
                } catch (error) {
                    resolve(res)
                }
            }).catch(reject)
        })
    }
	/**姓名脱敏 */
    Vue.prototype.formatName = function (str) {
        if (null != str && str != undefined) {
            if (str.length == 2) {
                return str.substring(0, 1) + '*' //截取name 字符串截取第一个字符，
            } else if (str.length == 3) {
                return str.substring(0, 1) + "*" + str.substring(2, 3)//截取第一个和第三个字符
            } else if (str.length > 3) {
                return str.substring(0, 1) + "*" + '*' + str.substring(3, str.length)//截取第一个和大于第4个字符
            }
        } else {
            return "";
        }
    }
    // 邮箱脱敏
    Vue.prototype.mailboxDesensitization = function (email) {
        var avg;
        var splitted;
        var email1;
        var email2;
        splitted = email.split('@');
        email1 = splitted[0];
        avg = email1.length / 2;
        email1 = email1.substring(0, email1.length - avg);
        email2 = splitted[1];
        return email1 + '***@' + email2; // 输出为81226***@qq.com
    }
	// 手机号脱敏
    Vue.prototype.desensitizePhone = function(phone) { 
        const desensitized = phone.substr(0, 3) + '****'+ phone.substring(phone.length - 4);  
        return desensitized;  
    }
	// 获取公司id
	Vue.prototype.getCompanyId = function(productCode){
        if(productCode&&productCode.includes('CCIC_EMPLOYER_LIABILITY')){
			return '10157'
		} else if(productCode=='SUNLIGHT_EMPLOYER_LIABILITY'){
			return '10027'
		}
    }
}
export default common


// WEBPACK FOOTER //
// ./src/common/index.js